import { render, staticRenderFns } from "./FishCounter.vue?vue&type=template&id=8d78f892&scoped=true"
import script from "./FishCounter.vue?vue&type=script&lang=ts"
export * from "./FishCounter.vue?vue&type=script&lang=ts"
import style0 from "./FishCounter.vue?vue&type=style&index=0&id=8d78f892&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d78f892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d78f892')) {
      api.createRecord('8d78f892', component.options)
    } else {
      api.reload('8d78f892', component.options)
    }
    module.hot.accept("./FishCounter.vue?vue&type=template&id=8d78f892&scoped=true", function () {
      api.rerender('8d78f892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/FishCounter.vue"
export default component.exports